import { DocumentForm } from "./documentForm";
import { Col, Row } from "reactstrap";
import { Button } from "antd";
import { ReloadOutlined, SaveOutlined } from "@ant-design/icons";

export const DocumentContent = ({
  onNext,
  currentStep,
  totalSteps,
  // submitted,
  onPrevious,
}) => {
  return (
    <div className="tab-content">
      <DocumentForm />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "24px",
          gap: "8px",
        }}
      >
        {currentStep > 1 && (
          <Button
            color="cyan"
            variant="solid"
            type="primary"
            onClick={onPrevious}
          >
            Previous
          </Button>
        )}

        {currentStep < totalSteps && (
          <Button
            color="cyan"
            variant="solid"
            type="primary"
            onClick={onNext}
            // disabled={submitted}
          >
            Next
          </Button>
        )}
      </div>
    </div>
  );
};
